import ObjectListWidget from '@plone/volto/components/manage/Widgets/ObjectListWidget';
import { normalizeItems } from './helper';

const ItemSchema = {
    title: 'Configurazione Header Slim',
    properties: {
        title_id: {
            description: "",
            factory: "Text line (String)",
            title: "ID Titolo",
            type: "string"
        },
        title_it: {
            description: "",
            factory: "Text line (String)",
            title: "Titolo Italiano",
            type: "string"
        },
        title_en: {
            description: "",
            factory: "Text line (String)",
            title: "Titolo Inglese",
            type: "string"
        },
        abilitato: {
            description: "Abilita o Disabilita la visualizzazione della voce nell'header",
            factory: "Yes/No",
            title: "Abilitato ?",
            type: "boolean"
        },
        statico: {
            description: "Abilita se la voce è un Link Statico",
            factory: "Yes/No",
            title: "Link statico ?",
            type: "boolean"
        },
        link_statico: {
            description: "Inserisci il link statico (se abilitato)",
            factory: "Text line (String)",
            title: "Link Statico",
            type: "string"
        },
        link_endpoint: {
            description: "Inserisci l'endpoint da cui recuperare l'HTML (se abilitato)",
            factory: "Text line (String)",
            title: "Link Endpoint",
            type: "string"
        },
        json: {
            description: "Inserisci il JSON per generare il dropdown (va in override agli altri metodi)",
            factory: "Text line (String)",
            title: "JSON del Dropdown",
            type: "string",
            widget: "textarea"
        },
    },
    fieldsets: [
        {
            id: 'header_slim_config',
            title: 'Configurazione Header Slim',
            fields: [
                'title_id',
                'title_it',
                'title_en',
                'abilitato',
                'statico',
                'link_statico',
                'link_endpoint',
                'json'
            ],
        },
    ],
    required: [],
};

const HeaderSlimWidget = (props) => {
    const items = normalizeItems(
        props.value?.items || props.default?.items || []
    );

    return (
        <ObjectListWidget
            schema={ItemSchema}
            {...props}
            value={items}
            onChange={(id, value) =>
                props.onChange(id, {
                    items: value.map(({ ['@id']: _, ...rest }) => rest),
                })
            }
        />
    );
};

export default HeaderSlimWidget;